export default "__VITE_ASSET__0cg1TZPl__"